import { render, staticRenderFns } from "./H5L.vue?vue&type=template&id=32fbcc10&scoped=true"
import script from "./H5L.vue?vue&type=script&lang=js"
export * from "./H5L.vue?vue&type=script&lang=js"
import style0 from "./H5L.vue?vue&type=style&index=0&id=32fbcc10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fbcc10",
  null
  
)

export default component.exports